import Cookies from 'cookies';
import { type GetServerSideProps } from 'next';
import Root, { type OwnProps as RootProps } from '~/Root';
import { RequestContext } from '~/server-props/contracts';
import enableTestErrorPage from '~/server-props/enableTestErrorPage';
import getProps from '~/server-props/getProps';
import getRedirects from '~/server-props/getRedirects';
import setDatadogUser from '~/server-props/setDatadogUser';

export default (props: RootProps) => <Root {...props} />;

export const getServerSideProps: GetServerSideProps<
  RootProps
> = async context => {
  // Sometimes *.js.map files are sent to SRP. Throw them out ASAP.
  if (context.resolvedUrl.includes('.js.map')) {
    return { notFound: true };
  }

  const serverCookies = new Cookies(context.req, context.res);
  const requestContext: RequestContext = {
    browserCookieId: String(context.req.cookies.BrowserCookieId),
    ipAddress: context.req.headers['x-forwarded-for'],
    referrer: context.req.headers.referer,
    url: context.req.url,
    userAgent: context.req.headers['user-agent']
  };

  const redirect = getRedirects(context);

  if (redirect) {
    return { redirect };
  }

  enableTestErrorPage(context);
  setDatadogUser(context, serverCookies);

  return getProps(context, requestContext, serverCookies);
};
